import React, { PureComponent } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, /*Legend*/ } from 'recharts';

export default class Chart extends PureComponent {
  constructor() {
    super();
    this.state = {
      data: []
    };
  }
  async componentDidMount() {
    const date = this.props.date;
    const yyyy = `${date.getFullYear()}`.padStart(4, '0');
    const mm = `${date.getMonth()+1}`.padStart(2, '0');
    const dd = `${date.getDate()}`.padStart(2, '0');
    const area = this.props.area ?? 'aks';
    const yyyymmdd = `${yyyy}${mm}${dd}`
//    const filename = `${area}${yyyymmdd}.csv`;

    const csv = await new Promise((resolve, reject) => {
//      const url = `http://localhost:3333/current/${filename}`;
      const url = `https://umiduri.furunosoftech.cloud/api/get-current?area=${area}&date=${yyyymmdd}`;
      fetch(url, {
        method: "GET",
      })
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        resolve(text);
      })
      .catch((err) => {
        reject(err);
      });
    });

    const data = [];
    csv.split('\n').forEach((line) => {
      const cols = line.split(',');
      if(cols[0].indexOf('24:00') < 0){
        data.push({
          time: ((new Date(cols[0]).getTime()/3600000 + 9) % 24),
          tide: parseFloat(cols[1]),
          koyomi: this.props.koyomi
        });
      }
    });
    this.setState({data});
  }
  render() {
    return (
        <LineChart
          width={200}
          height={200}
          data={this.state.data}
          margin={{top: 4, right: 4, bottom: -10, left: -40}}
        >
          <Tooltip content={<CustomTooltip direction={this.props.direction} />}/>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="time"
            type="number"
            tick={{fontSize: 'small'}}
            ticks={[0,6,12,18,24]}
          />
          <YAxis
            domain={[-8, 8]}
            type="number"
            tickCount={5}
            tick={{fontSize: 'small'}}
          />
          <Line type="monotone"
            dataKey="tide"
            stroke="#8884d8"
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
    );
  }
}


const CustomTooltip = ({ active, payload, label, direction }) => {
  if (active && payload && payload.length) {
    const hour = Math.trunc(label);
    const minute = Math.round((label - hour)*60);
    const hh = `${hour}`.padStart(2, '0');
    const mm = `${minute}`.padStart(2, '0');
    const current = payload[0].value;
    const dir = direction || { neg: '東', pos: '西' }; // propsが渡されない場合のフォールバック
    const directionText = current < 0 ? dir.neg : (current > 0 ? dir.pos : '転'); 

    return (
      <>
        <div className="label">{`${hh}:${mm}`}</div>
        <div className="value">{`${directionText}流 ${Math.abs(current).toFixed(1)}kn`}</div>
      </>
    );
  }

  return null;
};
